import { DateTime } from 'luxon'

import { PlaylistResponseDTO } from '@core/api/dtos/response/playlist/playlist'
import { Playlist } from '@core/api/entities/playlist/playlist'

import { PlaylistAnalyticsMapper } from './playlistAnalyticsMapper'
import { SongMapper } from '../song/songMapper'

export class PlaylistMapper {
	static toEntity(data: PlaylistResponseDTO): Playlist {
		let createdAt = DateTime.now()
		let updatedAt = DateTime.now()

		// Only parse dates if they exist in the response
		if (data.created_at) {
			const parsedCreatedAt = DateTime.fromISO(data.created_at)
			if (parsedCreatedAt.isValid) {
				createdAt = parsedCreatedAt
			} else {
				const fallbackCreatedAt = DateTime.fromFormat(
					data.created_at,
					'yyyy-MM-dd HH:mm:ss'
				)
				if (fallbackCreatedAt.isValid) {
					createdAt = fallbackCreatedAt
				}
			}
		}

		if (data.updated_at) {
			const parsedUpdatedAt = DateTime.fromISO(data.updated_at)
			if (parsedUpdatedAt.isValid) {
				updatedAt = parsedUpdatedAt
			} else {
				const fallbackUpdatedAt = DateTime.fromFormat(
					data.updated_at,
					'yyyy-MM-dd HH:mm:ss'
				)
				if (fallbackUpdatedAt.isValid) {
					updatedAt = fallbackUpdatedAt
				}
			}
		}

		return new Playlist({
			id: data.id,
			title: data.title,
			titleTranslations: data.title_translations,
			description: data.description || '',
			descriptionTranslations: data.description_translations,
			contentCategoryIds: data.content_category_ids || [],
			public: data.public || false,
			cover: data.cover,
			thumbs: data.thumbs,
			hash: data.hash || '',
			createdAt,
			updatedAt,
			feedbackDropRatio: data.feedback_drop_ratio,
			songs: data.songs?.data
				? SongMapper.toEntities(data.songs.data)
				: undefined,
			highlightedSongs: data.highlighted_songs?.data
				? SongMapper.toEntities(data.highlighted_songs.data)
				: undefined,
			analytics: data.analytics
				? PlaylistAnalyticsMapper.toEntity(data.analytics)
				: undefined,
			reviewed: data.reviewed,
			percentage: data.percentage,
		})
	}

	static toEntities(data: PlaylistResponseDTO[]): Playlist[] {
		return data.map((playlist) => this.toEntity(playlist))
	}
}
